import intl from "react-intl-universal";
import { TbCircleCheck } from "react-icons/tb";
import { getBaasApiPeriodOptions } from "../../../../../Services/baasApiApi";

const selectClass =
  "h-9 min-w-[140px] rounded-lg border border-gray-200 bg-white px-3 text-sm text-brand-dark outline-none transition focus:border-[#e7a73f] dark:border-brand-dark-border dark:bg-brand-dark-elevated dark:text-gray-100";

const HEALTH_STYLES = {
  healthy: "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
  degraded: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300",
  down: "bg-red-50 text-red-600 dark:bg-red-950/40 dark:text-red-300",
  unknown: "bg-gray-100 text-gray-600 dark:bg-brand-dark-elevated dark:text-gray-300",
};

export const BaasApiFilterBar = ({ filters, onFiltersChange, healthStatus = "unknown" }) => {
  const periods = getBaasApiPeriodOptions();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <label className="text-xs font-medium text-gray-500 dark:text-gray-400">
          {intl.get("baas.api.filters.period")}
        </label>
        <select
          className={selectClass}
          value={filters.period}
          onChange={(event) =>
            onFiltersChange({ ...filters, period: event.target.value })
          }
        >
          {periods.map((period) => (
            <option key={period} value={period}>
              {intl.get(`baas.api.period.${period}`)}
            </option>
          ))}
        </select>
      </div>

      <span
        className={`ml-auto inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${
          HEALTH_STYLES[healthStatus] ?? HEALTH_STYLES.healthy
        }`}
      >
        <TbCircleCheck className="h-3.5 w-3.5" />
        {intl.get(`baas.api.health.${healthStatus}`)}
      </span>
    </div>
  );
};
